/** `node:path`, POSIX only. */
import { norm } from "./vfs"
export const sep = "/"
export const delimiter = ":"
export function isAbsolute(p: string): boolean {
  return p.startsWith("/")
}
export function normalize(p: string): string {
  if (p === "") return "."
  const abs = p.startsWith("/")
  const out: string[] = []
  for (const part of p.split("/")) {
    if (part === "" || part === ".") continue
    if (part === "..") {
      if (out.length > 0 && out[out.length - 1] !== "..") out.pop()
      else if (!abs) out.push("..")
    } else out.push(part)
  }
  const s = out.join("/")
  return abs ? `/${s}` : s === "" ? "." : s
}
export function join(...parts: string[]): string {
  return normalize(parts.filter((p) => p !== "").join("/"))
}
export function resolve(...parts: string[]): string {
  let acc = ""
  for (const p of parts) acc = p.startsWith("/") ? p : acc === "" ? p : `${acc}/${p}`
  return norm(acc === "" ? "/work" : acc)
}
export function dirname(p: string): string {
  const n = normalize(p)
  const i = n.lastIndexOf("/")
  if (i < 0) return "."
  return i === 0 ? "/" : n.slice(0, i)
}
export function basename(p: string, ext?: string): string {
  const b = normalize(p).split("/").pop() ?? ""
  return ext !== undefined && b.endsWith(ext) ? b.slice(0, -ext.length) : b
}
export function extname(p: string): string {
  const b = basename(p)
  const i = b.lastIndexOf(".")
  return i <= 0 ? "" : b.slice(i)
}
export function relative(from: string, to: string): string {
  const a = resolve(from).split("/").filter(Boolean)
  const b = resolve(to).split("/").filter(Boolean)
  let i = 0
  while (i < a.length && i < b.length && a[i] === b[i]) i++
  return [...a.slice(i).map(() => ".."), ...b.slice(i)].join("/")
}
export const posix = { sep, delimiter, isAbsolute, normalize, join, resolve, dirname, basename, extname, relative }
export default posix
